import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

const usePageViews = () => {
  const location = useLocation();

  useEffect(() => {
    if (!location) {
      return;
    }

    ReactGA.send({ hitType: "pageview", page: location?.pathname });
  }, [location]);
};

export default usePageViews;
